import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, resolveDirective as _resolveDirective, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 g-0" }
const _hoisted_2 = { class: "form-group align-item-center col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2 d-flex align-items-center" }, "Service Required", -1 /* HOISTED */)
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "d-flex flex-wrap" }
const _hoisted_6 = ["value", "id"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "form-group d-flex col-12 pt-4" }
const _hoisted_9 = { class: "form-group col-6 px-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "height" }, " Height ", -1 /* HOISTED */)
const _hoisted_11 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "flex-row pb-0 rounded-1 input-group-text" }
const _hoisted_14 = { class: "form-check pe-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "in"
}, " in ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-check custom-radio" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "cm"
}, " cm ", -1 /* HOISTED */)
const _hoisted_18 = { class: "form-group px-4 col-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "weight" }, " Weight ", -1 /* HOISTED */)
const _hoisted_20 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_21 = { class: "flex-grow-1" }
const _hoisted_22 = { class: "flex-row pb-0 rounded-1 input-group-text" }
const _hoisted_23 = { class: "form-check pe-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "lb"
}, " lb ", -1 /* HOISTED */)
const _hoisted_25 = { class: "form-check custom-radio" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "kg"
}, " kg ", -1 /* HOISTED */)
const _hoisted_27 = { class: "form-group col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2 d-flex align-items-center" }, "DME Needed", -1 /* HOISTED */)
const _hoisted_29 = { class: "d-flex flex-wrap" }
const _hoisted_30 = ["value"]
const _hoisted_31 = ["id", "value"]
const _hoisted_32 = ["for"]
const _hoisted_33 = {
  key: 0,
  class: "form-group col-12 col-lg-12 px-4 col-md-12 g-0"
}
const _hoisted_34 = { class: "form-group col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2 d-flex align-items-center" }, "Medication History", -1 /* HOISTED */)
const _hoisted_36 = { class: "form-check custom-checkbox pb-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "medication-history"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Patient consents to the agency utilizing the Surescripts Medication History interface to pull a history of medications taken? ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Service Required",
    type: "his-section",
    "full-height": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfService, (service, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "form-check col-4 custom-checkbox pb-2 pe-4"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: String(index),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Clinical.ServicesRequiredCollection) = $event)),
                    class: "form-check-input",
                    id: service.name,
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectedServices && _ctx.selectedServices(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6), [
                    [_vModelCheckbox, _ctx.referral.Clinical.ServicesRequiredCollection]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: service.name
                  }, [
                    _createElementVNode("small", null, _toDisplayString(`${service.name} (${service.fullForm})`), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_7)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    name: "height",
                    maxlength: "9",
                    class: "form-control h-95 no-border-radius",
                    type: "text",
                    placeholder: "Enter Height",
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.heightOnChange && _ctx.heightOnChange(...args))),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Clinical.Height) = $event))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_directive_number_only],
                    [_vModelText, _ctx.referral.Clinical.Height]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "in",
                      value: "1",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.Clinical.HeightMetric) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _ctx.referral.Clinical.HeightMetric]
                    ]),
                    _hoisted_15
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "cm",
                      value: "2",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Clinical.HeightMetric) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _ctx.referral.Clinical.HeightMetric]
                    ]),
                    _hoisted_17
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", null, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    name: "weight",
                    maxlength: "9",
                    class: "form-control h-95 no-border-radius",
                    type: "text",
                    placeholder: "Enter Weight",
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.weightOnChange && _ctx.weightOnChange(...args))),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.Clinical.Weight) = $event))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_directive_number_only],
                    [_vModelText, _ctx.referral.Clinical.Weight]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "lb",
                      value: "1",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.Clinical.WeightMetric) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _ctx.referral.Clinical.WeightMetric]
                    ]),
                    _hoisted_24
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input",
                      id: "kg",
                      value: "2",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.Clinical.WeightMetric) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelRadio, _ctx.referral.Clinical.WeightMetric]
                    ]),
                    _hoisted_26
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.dmeNeededEnum), ([key, value], index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-check col-4 custom-checkbox pb-2 pe-4",
                value: value.value,
                key: key
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: `dme-needed-${value.name}`,
                  value: String(index),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Clinical.DMECollection) = $event)),
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.selectedDMEServices && _ctx.selectedDMEServices(...args)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_31), [
                  [_vModelCheckbox, _ctx.referral.Clinical.DMECollection]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `dme-needed-${value.name}`
                }, [
                  _createElementVNode("small", null, _toDisplayString(value.name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_32)
              ], 8 /* PROPS */, _hoisted_30))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        (_ctx.referral.Clinical.DMECollection.includes('10'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onOtherDMEChange && _ctx.onOtherDMEChange(...args))),
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.Clinical.OtherDME) = $event))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, _ctx.referral.Clinical.OtherDME]
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: "medication-history",
              onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.medicationHistoryChange && _ctx.medicationHistoryChange(...args))),
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.Clinical.IsMedicationHistoryEnabled) = $event))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelCheckbox, _ctx.referral.Clinical.IsMedicationHistoryEnabled]
            ]),
            _hoisted_37
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}